import type { VFC } from 'react';

import { Link } from 'react-router-dom';

import { Button } from '../Button/Button';
import type { ButtonProps } from '../Button/Button';
import { isLocalUrl, getPathFromUrl } from '../../shared/helpers/routes';

interface LinkButtonProps extends Omit<ButtonProps<'a'>, 'component' | 'href'> {
  url: string;
}

export const LinkButton: VFC<LinkButtonProps> = ({ url, ...props }) => {
  if (isLocalUrl(url)) {
    return <Button component={Link} to={getPathFromUrl(url)} {...props} />;
  }

  return <Button component="a" href={url} {...props} />;
};
